export { PublicationsSearch } from './PublicationsSearch.component';
